(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  // Physical product types verified in the store. Body-copy mentions of
  // accessories do not make food or veterinary medicines accessory matches.
  const accessoryTypes = ['Cepillos y deslanadores','Camas para perros','Bebederos para mascotas','Collares y correas para perro','Areneros y accesorios para gato','Bebederos','Peines y Cepillos','Tapetes Entrenadores','Camas','Comederos','Cepillos y Peines','Bebederos y Comederos','Areneros','Jaulas y Transportadoras','Jaulas para Mascotas','Bolsas y Transportadoras'];
  const accessoryTypeNames = new Set(accessoryTypes.map(normalize));
  const accessoryQuery = query => {
    const terms = normalize(query).split(/\s+/).filter(word => word && !/^(accesorios?|para|de|el|la|los|las|perros?|gatos?|canine|feline)$/.test(word));
    return '(' + accessoryTypes.map(type => 'product_type:' + JSON.stringify(type)).join(' OR ') + ')' + terms.map(term => ' AND ' + JSON.stringify(term)).join('');
  };
  const renalMatch = (text, data) => data.brand === 'Virbac' ? /\brenal\b|\bkidney\b/.test(text) : /\brenal\b|kidney function|kidney support/.test(text);
  const intent = query => {
    const text = normalize(query).replace(/\s+/g,' ').trim();
    const foodCategory = /\balimentos?\b|\bcomidas?\b|\bcroquetas?\b/.test(text);
    const toyCategory = /\bjuguetes?\b|\bpelotas?\b/.test(text);
    const accessoryCategory = /\baccesorios?\b/.test(text);
    const cat = /\bgatos?\b|\bfeline\b/.test(text), dog = /\bperros?\b|\bcanine\b/.test(text);
    return {renal:/\brenal\b|kidney function|kidney support/.test(text), species:cat !== dog ? cat ? 'Gatos' : 'Perros' : '', food:foodCategory || /\bpurina\b|\broyal\b|\bnf\b/.test(text), brand:/\bpurina\b/.test(text) ? 'Purina Pro Plan' : /\broyal\b/.test(text) ? 'Royal Canin' : /\bvirbac\b/.test(text) ? 'Virbac' : '', category:toyCategory && !foodCategory ? 'Juguetes' : foodCategory && !toyCategory ? 'Alimentos' : accessoryCategory && !foodCategory && !toyCategory ? 'Accesorios' : ''};
  };
  const parameters = query => {
    const data = intent(query), params = new URLSearchParams({q:query,type:'product'});
    if (data.renal) {
      params.set('q',data.brand === 'Virbac' ? 'title:renal OR title:kidney' : /kidney\s+support/i.test(query) ? 'renal OR "Kidney Function" OR "Kidney Support"' : 'renal OR "Kidney Function"');
      params.set('options[prefix]','none');
      params.set('clq',query);
      if(data.food) params.set('filter.p.m.clikea.categoria','Alimentos');
      if(data.species) params.set('filter.v.m.clikea.especie',data.species);
      if(data.brand) params.set('filter.p.vendor',data.brand);
    } else if (data.category === 'Accesorios') {
      params.set('q',accessoryQuery(query));
      if(data.species) params.set('filter.v.m.clikea.especie',data.species);
      params.set('clq',query);
    } else if (data.category) {
      params.set('filter.p.m.clikea.categoria',data.category);
      if(data.species) params.set('filter.v.m.clikea.especie',data.species);
      params.set('clq',query);
    }
    return params;
  };
  const rank = (products, query) => {
    const data = intent(query), tokens = normalize(query).split(/\s+/).filter(Boolean);
    return products.filter(product => {
      const text = normalize(product.title + ' ' + product.product_type), species = product.species;
      if(data.category === 'Accesorios' && !accessoryTypeNames.has(normalize(product.product_type)))return false;
      if(data.renal && data.brand && normalize(product.vendor) !== normalize(data.brand))return false;
      if(data.species && (species ? !species.includes(data.species) : data.species === 'Gatos' ? /\bperros?\b|\bcanine\b/.test(text) && !/\bgatos?\b/.test(text) : /\bgatos?\b|\bfeline\b/.test(text) && !/\bperros?\b/.test(text)))return false;
      return !data.renal || renalMatch(text,data);
    }).sort((a,b) => {
      if(['Juguetes','Accesorios'].includes(data.category) && a.available !== b.available)return Number(b.available === true)-Number(a.available === true);
      const score=p=>tokens.reduce((sum,t)=>sum+(normalize(p.title+' '+p.vendor+' '+p.product_type).includes(t)?1:0),0);
      return score(b)-score(a);
    });
  };
  const suggestions = async (query,signal) => {
    const params=parameters(query);params.set('section_id','clikea-search-suggestions');
    const read=async parameters=>{
      const response=await fetch('/search?'+parameters,{signal});
      if(!response.ok)throw Error('Search unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const source=doc.querySelector('[data-clux-search-results]');
      if(!source)throw Error('Search response unavailable');
      return JSON.parse(source.textContent);
    };
    const matches=await read(params);
    if(matches.length || ![...params.keys()].some(key=>key.startsWith('filter.')))return matches;
    // Imported products can lack indexed category/species metadata. One bounded
    // native search shares the original abort/deadline; positive local evidence
    // still has to establish the requested category, species and brand.
    const fallback=new URLSearchParams(params);
    const data=intent(query);
    for(const key of [...fallback.keys()])if(key.startsWith('filter.') && !(data.renal && data.brand && key === 'filter.p.vendor'))fallback.delete(key);
    return (await read(fallback)).filter(product=>{
      const type=normalize(product.product_type),text=normalize(product.title+' '+product.product_type);
      if(data.category==='Alimentos' && !/\balimentos?\b|\bcroquetas?\b|\bfood\b/.test(type))return false;
      if(data.category==='Juguetes' && !/\bjuguetes?\b|\btoys?\b/.test(type))return false;
      if(data.category==='Accesorios' && !accessoryTypeNames.has(type))return false;
      if(data.brand && normalize(product.vendor)!==normalize(data.brand))return false;
      if(data.species){
        if(Array.isArray(product.species) && product.species.length){if(!product.species.includes(data.species))return false;}
        else if(data.species==='Gatos' ? !/\bgatos?\b|\bfelin[eo]s?\b/.test(text) : !/\bperros?\b|\bcanin[eo]s?\b/.test(text))return false;
      }
      return !data.renal || renalMatch(text,data);
    });
  };
  window.ClikeaSearch={intent,parameters,rank,suggestions};
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement) || !new URL(form.action,location.origin).pathname.endsWith('/search'))return;
    const input=form.querySelector('[name=q]');
    if(!input || /\bOR\b|\w+:/.test(input.value) || !(intent(input.value).renal || intent(input.value).category))return;
    event.preventDefault();
    location.assign(new URL(form.action,location.origin).pathname+'?'+parameters(input.value.trim()));
  },true);
  const humanQuery=new URLSearchParams(location.search).get('clq');
  const current=new URLSearchParams(location.search),directQuery=current.get('q');
  const hasExplicitFilters = [...current.keys()].some(key=>key.startsWith('filter.'));
  const mappedQuery = directQuery && (intent(directQuery).renal || intent(directQuery).category);
  if(location.pathname.endsWith('/search') && mappedQuery && !humanQuery && !hasExplicitFilters && !/\bOR\b|\w+:/.test(directQuery)){
    const next=parameters(directQuery);
    for(const [key,value] of current){if(key!=='q' && key!=='page' && !next.has(key))next.append(key,value);}
    location.replace(location.pathname+'?'+next);
    return;
  }
  if(humanQuery){
    const humanIntent=intent(humanQuery);
    if(humanIntent.category === 'Accesorios' || (humanIntent.renal && humanIntent.brand === 'Virbac'))document.title='Resultados para «'+humanQuery+'» | CLIKEA PETS';
    document.querySelectorAll('[data-clux-results-search] [name=q]').forEach(input=>input.value=humanQuery);
    const empty=document.querySelector('.clux-empty-search h2');if(empty)empty.textContent='No encontramos «'+humanQuery+'»';
    const clear=document.querySelector('[data-clux-clear-search]');if(clear)clear.href='/search?'+new URLSearchParams({q:current.get('q'),clq:humanQuery,type:'product'});
    // Native removal links omit custom query parameters. Keep the human query
    // marker so removing a suggested filter does not immediately add it again.
    document.addEventListener('click',event=>{
      const link=event.target instanceof Element ? event.target.closest('a[href]') : null;
      if(!link)return;
      const url=new URL(link.href,location.origin);
      if(url.origin!==location.origin || !url.pathname.endsWith('/search') || url.searchParams.get('q')!==current.get('q'))return;
      url.searchParams.set('clq',humanQuery);
      link.href=url.href;
    },true);
  }
})();
